/**
 * @generated SignedSource<<381583b0bc5872dc8fae6f92769d81bf>>
 * @relayHash dd4cb38cf1dac25715ea9172302f4916
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52d939acfe36fa02eb3ab8eff4fa4a3efba48895738e871d13d5ac10d94bdb7a

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GenerateSignInTokenMutationInput = {
  authRedirectPath?: string | null | undefined;
  email: string;
};
export type SignUpScreenContentSignInMutation$variables = {
  input: GenerateSignInTokenMutationInput;
};
export type SignUpScreenContentSignInMutation$data = {
  readonly generateSignInToken: {
    readonly __typename: string;
  };
};
export type SignUpScreenContentSignInMutation = {
  response: SignUpScreenContentSignInMutation$data;
  variables: SignUpScreenContentSignInMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "generateSignInToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpScreenContentSignInMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignUpScreenContentSignInMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "52d939acfe36fa02eb3ab8eff4fa4a3efba48895738e871d13d5ac10d94bdb7a",
    "metadata": {},
    "name": "SignUpScreenContentSignInMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e43ba0d01ca319643fe2a648c7cbd264";

export default node;
